/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ station: NonNullable<unknown> }} Camera_Station_TitleInputs */

const vi_camera_station_title = /** @type {(inputs: Camera_Station_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Camera của trạm ${i?.station}`)
};

/**

* @param {Camera_Station_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_title = /** @type {((inputs: Camera_Station_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_title(inputs)
});